import React, { useMemo } from "react";
import {
    GiftingCartError,
    buildErrorPagePropsForErrorType,
    GIFTING_CART_ERROR_TYPE,
    useEffectOnce,
} from "@swiggy-private/core-ui";
import { goToGiftingHome } from "@swiggy-private/checkout-core";

export const DefaultGiftingCartError = ({ nrEventHandler }: { nrEventHandler?: (screenType: string) => void }) => {
    const props = useMemo(() => {
        const errorProps = buildErrorPagePropsForErrorType({
            primaryActionOnClick: goToGiftingHome,
        });
        return errorProps[GIFTING_CART_ERROR_TYPE.DEFAULT];
    }, []);

    useEffectOnce(() => {
        nrEventHandler?.(GIFTING_CART_ERROR_TYPE.DEFAULT);
    });

    return <GiftingCartError {...props} />;
};
